module.exports = __webpack_public_path__ + "img/icon_cancelW.7d963fcd.svg";